<template>
    <div class="sales-category-list">
        <div class="title">
            <h3>服务费率管理</h3>
        </div>
        <div class="search-box">
            <el-input v-model="searchName" placeholder="请输入公司名称" size="mini" style="width: 200px;margin-right: 50px;"></el-input>
            <el-button type="primary" size="mini" @click="handleRequest">查询</el-button>
            <el-button type="primary" size="mini" @click="handleReset">重置</el-button>
        </div>
        <div class="table-box" >
            <el-table :data="data">
                <el-table-column type="index" width="50"></el-table-column>
                <!-- 分类名称 -->
                <el-table-column prop="shopName" label="公司名称" ></el-table-column>
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button type="text"  @click="handleEdit(scope.$index)">设置</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination 
            :total="page.total" 
            :page-size="page.pageSize"
            :current-page="page.currentPage" 
            layout="total,sizes, prev, pager, next, jumper" 
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
        >
        </el-pagination>
        <SalesRateDialog ref="salesRateDialog"  :shopId="dialogShopId" :shopName="dialogShopName"></SalesRateDialog>
    </div>
</template>

<script>
import SalesRateDialog from './components/SalesRateDialog.vue'
import { queryShopManageList } from "@/api/businessManage";
export default {
    name: 'SalesCategoryList',
    components: {
        SalesRateDialog
    },
    data() {
        return {
            // 搜索框
            searchName: '',
            // 分页信息
            page: {
                total: 0,
                pageSize: 20,
                currentPage: 1
            },
            // 列表数据
            data: [],
            dialogShopId: '',// 弹窗的shopId
            dialogShopName: ''// 弹窗的shopName
        }
    },
    methods: {
        // 查询列表
        queryList() {
            const obj = {
                shopName: this.searchName,
                current: this.page.currentPage,
                size: this.page.pageSize,
                status: "2"
            }
            queryShopManageList(obj).then(response => {
                if (response.data.records && response.data.records.length > 0) {
                    this.data = response.data.records
                    this.page.total = response.data.total
                } else {
                    this.data = []
                    this.page.total = 0
                }
            })
        },
        // 编辑按钮的方法
        handleEdit(index) {
            const row = this.data[index]
            this.dialogShopId = row.id
            this.dialogShopName = row.shopName
            this.$refs.salesRateDialog.handleDialogVisible()
        },
        handleRequest() {
            // 处理查询请求
            this.page.currentPage = 1
            this.queryList()
        },
        handleReset() {
            // 处理重置请求
            this.searchName = ''
            this.page.currentPage = 1
            this.queryList()
        },
        handleCurrentChange(currentPage) {
            // 处理分页请求
            this.page.currentPage = currentPage
            this.queryList()
        },
        handleSizeChange(pageSize) {
            // 处理分页请求
            this.page.pageSize = pageSize
            this.queryList()
        }
    },
    created() {
        this.queryList()
    }
}
</script>
<style scoped lang="scss">
.sales-category-list{
    padding: 20px;
    background-color: #fff;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex:1;
    .title{
        display: flex;
        justify-content: space-between;
        align-items: center;
        h3{
            margin: 0px;
        }
    }
    .search-box{
        display: flex;
        align-items: center;
        margin-top: 10px;
    }
    .table-box{
        display: flex;
        flex:1;
        overflow-y: auto;
        .el-table{
            width: 100%;
            overflow-y: auto;
        }
    }
    .sort-buttons{
        .sort-button{
            margin: 0px;
            border-radius: 0px;
        }
        .el-button:first-child{
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
        }
        .el-button:last-child{
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
        }
    }
}
</style>